import { useMemo } from 'react';

import { type StreamStatusData } from '@okvc/schema';

import { WebSocketMessageTypes } from '../../models/index.js';
import useWebSocket from '../../providers/useWebSocket.js';

const useStreamStatus = (streamIds: string[]): Map<string, StreamStatusData> => {
  const { messages } = useWebSocket<StreamStatusData>();
  return useMemo(() => {
    const statusByStreamId = new Map<string, StreamStatusData>();
    for (const message of messages) {
      if (message.event === WebSocketMessageTypes.STREAM_STATUS && streamIds.includes(message.data.streamId)) {
        statusByStreamId.set(message.data.streamId, message.data);
      }
    }
    return statusByStreamId;
  }, [messages, streamIds]);
};

export default useStreamStatus;
